import * as React from 'react'
import EecTracking from 'theme/atoms/EecTracking'
import styled from 'styled-components'
import theme from 'theme'

import * as t from './types'
import Teaser from './Teaser'

export default function BrandTeaser(props: t.Props) {
  const brands = props.items

  return (
    <EecTracking
      config={props.eecTracking}
      gridArea={props.gridArea}
      threshold={1}
    >
      <Wrapper data-cy-ctx="organisms/BrandTeaser">
        <div>
          <div className="headline">{props.label}</div>
          <div className="brand-wrapper">
            {brands.map((item, i) => (
              <div className="teaser-wrapper" key={i}>
                <Teaser
                  imgSrc={props.context.optImages[i]}
                  linkLabel={item.linkLabel}
                  logo={item.logo}
                  name={item.name}
                  to={item.link}
                />
              </div>
            ))}
          </div>
        </div>
      </Wrapper>
    </EecTracking>
  )
}

const Wrapper = styled.div`
  width: 100% auto;

  > div {
    display: block;
    width: 100%;

    > .headline {
      height: 1.75rem;
      margin-top: ${theme.spacing('ml')};
      margin-bottom: 1rem;
      ${theme.ty('rc-2xl')};
      @media (min-width: ${theme.ms.XL}px) {
        display: block;
        height: 2.25rem;
        ${theme._ty([28, 0, 36], theme.fontSpecial, '400')};
        line-height: 2.25rem;
        margin-bottom: ${theme.spacing('m')};
      }
    }

    > .brand-wrapper {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));
      grid-auto-rows: 1fr;
      grid-gap: ${theme.spacing('s')};
      @media (min-width: ${theme.ms.SM}px) {
        grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
        grid-auto-rows: 1fr;
        grid-gap: ${theme.spacing('m')};
      }
      @media (min-width: ${theme.ms.MD}px) {
        grid-template-columns: repeat(auto-fill, minmax(11rem, 1fr));
        grid-auto-rows: 1fr;
        grid-gap: ${theme.spacing('xxs')};
      }
      @media (min-width: ${theme.ms.LG}px) {
        grid-template-columns: repeat(auto-fill, minmax(13rem, 1fr));
        grid-auto-rows: 1fr;
        grid-gap: ${theme.spacing('m')};
      }
      @media (min-width: ${theme.ms.XL}px) {
        grid-template-columns: repeat(auto-fill, minmax(17rem, 1fr));
        grid-auto-rows: 1fr;
        grid-gap: 1rem;
      }

      &:before {
        content: '';
        width: 0;
        padding-bottom: 100%;
        grid-row: 1 / 1;
        grid-column: 1 / 1;
      }

      *:first-child {
        grid-row: 1 / 1;
        grid-column: 1 / 1;
      }
    }
  }
`
